export default __webpack_public_path__ + "static/media/gel-lavenda-1.d77d269e.jpg";